import createLumirIcon from "../create-lumir-icon";

const ChevronRight = createLumirIcon("ChevronRight", [
  [
    "path",
    {
      key: "chevron-right",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M7.3336 18C6.99228 18 6.65095 17.8432 6.39096 17.5312C5.86964 16.9055 5.86964 15.8943 6.39096 15.2686L10.7975 9.98023L6.55762 4.71105C6.04697 4.0742 6.06163 3.06133 6.59095 2.44848C7.12161 1.83564 7.96558 1.85324 8.47624 2.48689L13.6254 8.88735C14.1308 9.5162 14.1241 10.5131 13.6094 11.1307L8.27624 17.5312C8.01625 17.8432 7.67492 18 7.3336 18Z",
    },
  ],
]);

export default ChevronRight;
